<script lang="ts">
  import type { HTMLButtonAttributes } from "svelte/elements";
  import { getStep } from "../../lib/workflow/workflowLib.svelte";
  import { turboSubmitOk } from "../../lib/turboSubmitOk";
  import { sleep } from "../../lib/sleep";
  import WaitButton from "../WaitButton.svelte";

  let {
    label = "Continue",
    onclick: providedOnclick = undefined,
    onwait = undefined,
    disabled = false,
    type = "submit",
    class: className = "btn-primary",
    name = undefined,
    value = undefined,
  }: Omit<HTMLButtonAttributes, "onclick"> & {
    label?: string;
    onclick?: (e: MouseEvent) => void | Promise<any> | any;
    onwait?: () => (() => void) | void;
  } = $props();

  const step = getStep();
  let button = $state<HTMLButtonElement>();
  const onclick = async (e: MouseEvent) => {
    const valid = button?.form?.reportValidity() && (!providedOnclick || (await providedOnclick(e)));
    e.preventDefault();
    if (!valid) return;
    if (type != "submit") return step.next();

    return step.next(async ()=>{
      const afterWaitCallback = onwait?.();
      const succeeded = await turboSubmitOk(button!);
      await sleep(200); // hack to wait for component update to complete, definitely longer than needed
      if (afterWaitCallback) afterWaitCallback();
      if (!succeeded) return false;
    })
  };
</script>

<WaitButton bind:button {type} {onclick} {disabled} {name} {value} class="btn {className}">
  {label}
</WaitButton>
